import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationStatus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 29, viewBox: "0 0 28 29", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1.5, width: 26, height: 26, fill: "#582534" }), /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1.5, width: 26, height: 26, stroke: "currentColor", strokeWidth: 2, strokeLinejoin: "bevel" }));
const ForwardRef = forwardRef(SvgNotificationStatus);
export { ForwardRef as ReactComponent };
